import { TRAY_SERVICE } from 'types/rofl';

import hubspotIcon from '../assets/icons/hubspot.png';
import marketoIcon from '../assets/icons/marketo.svg';
import salesforceIcon from '../assets/icons/salesforce.svg';
import rollworksIcon from '../assets/icons/rollworks.svg';

export interface IEntity {
    name: string;
    // Ex: Workflow
    title: string;
}

export interface IService {
    icon: string;
}

export const SERVICES: {
    [TRAY_SERVICE.HUBSPOT]: IService;
    [TRAY_SERVICE.MARKETO]: IService;
    [TRAY_SERVICE.SALESFORCE]: IService;
    [TRAY_SERVICE.ROLLWORKS]: IService;
} = {
    hubspot: {
        icon: hubspotIcon,
    },
    marketo: {
        icon: marketoIcon,
    },
    salesforce: {
        icon: salesforceIcon,
    },
    rollworks: {
        icon: rollworksIcon,
    },
};
